module.exports = __webpack_public_path__ + "img/05.cfedfec8.jpg";